import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class NetworkWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "home", title: "Network Home", href: "/network/" },
            { icon: "logs", title: "Logs", href: "/network/logs" },
            { icon: "cloud", title: "Media Servers", href: "/network/media-servers" },
            { icon: "search", title: "Redis Search", href: "/network/redis" },
            { icon: "server", title: "Redis Cluster Info", href: "/network/redis-info" }
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
